type IInitialConfigPayload = {};

export function initialConfigPayload(values: any): IInitialConfigPayload {
  const payload: IInitialConfigPayload = {
    ...values,
  };
  return payload;
}
